import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import { ImportserialService } from "../../services/importserial.service";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { AccountsTransactionType, Channel } from "src/app/finance/constants/constants";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";

@Component({
    selector: "app-bill-view",
    templateUrl: "./bill-view.component.html",
    styleUrls: ["./bill-view.component.scss"],
})
export class BillViewComponent implements OnInit, OnChanges {

    @Input() billDetails;
    @Input() fromPO: boolean = false;
    @Input() isView: boolean = false;

    @Output() openScanInfoChild = new EventEmitter();
    @Output() updateJournalList = new EventEmitter<boolean>();
    @Output() close = new EventEmitter<boolean>();

    index: number = 0;
    length: number = 0;
    baseCurrency;
    orgCurrency = [];
    qtyDecimal: number = 0;
    selectedChannel: any = null;
    expenses = [];
    receivePurchaseListTB = [];
    notes: string = "";
    subTotal: number = 0;
    discount: number = 0;
    shippingAmount: number = 0;
    orderTotal: number = 0;
    lineTotal: number = 0;
    billTemplate;
    footerTaxEnabled: boolean = false;
    glApiCall = false;
    transactionTypeIds = AccountsTransactionType;
    billId: number;
    isAllowPostingPeriod: boolean = false;

    constructor(public app: AppMainComponent, private importService: ImportserialService,
        private purchaseService: PurchasesService, private utilityService: UtilityService) { }

    ngOnInit(): void {
        this.importService.getDecimalValue().subscribe(value => {
            if (value) {
                this.length = value;
            }
        })

        this.importService.getQtyDecimalValue().subscribe(value => {
            if (value) {
                this.qtyDecimal = value;
            }
        })

        this.importService.getOrgCurrency().subscribe(value => {
            if (value) {
                this.baseCurrency = value.find(cr => cr.isBaseCurrency);
                this.orgCurrency = value;
            }
        })
        this.getIsettings();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.billDetails?.currentValue) {
            this.billId = this.billDetails.id;
            this.billDetails = changes.billDetails.currentValue;
            this.parseBillDetails();
            if(!this.billTemplate){
                this.getBillTemplate();
            }
        }
    }

    getBillTemplate() {
        this.purchaseService.getPOConfigurations('Purchase')
            .subscribe((configs) => {
                const purchaseTemplate = configs?.find(config => config.name == 'Purchase Template');
                if (purchaseTemplate?.configurationDetails.length > 0) {
                    const allPurchaseTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
                    this.billTemplate = allPurchaseTemplates?.find((t) => t.producttypeId == Channel.Bill);
                    this.footerTaxEnabled = !this.billTemplate?.labels_table[5]?.isChecked && this.billTemplate?.labels_footer[4]?.isChecked;
                }
            });
    }

    parseBillDetails() {
        this.billTemplate = this.billDetails?.configJson ? JSON.parse(this.billDetails?.configJson) : null;
        this.footerTaxEnabled = !this.billTemplate?.labels_table[5]?.isChecked && this.billTemplate?.labels_footer[4]?.isChecked;
        this.billDetails.postingDate = this.billDetails?.postingDate ? this.app._showDateTimeWithZone(this.billDetails?.postingDate) : null;
        this.selectedChannel = { id: this.billDetails?.templateId };
        this.receivePurchaseListTB = [];
        this.expenses = this.billDetails.billOrderExpense?.map(exp => ({
            ...exp,
            amount: Number(exp.amount) * Number(this.billDetails?.exchangeRate ?? 1) // Fallback to 1 if exchangeRate is undefined
        }));
        this.index = this.expenses?.length ? 0 : 1;
        this.subTotal = Number(this.billDetails.totalAmount) * Number(this.billDetails?.exchangeRate);
        this.notes =
            this.billDetails.receivedPurchaseOrderNotes &&
                this.billDetails.receivedPurchaseOrderNotes.length > 0
                ? this.billDetails.receivedPurchaseOrderNotes[this.billDetails?.receivedPurchaseOrderNotes.length - 1].note.comment
                : "";
        this.shippingAmount = Number(this.billDetails.shippingChargeAmount) * Number(this.billDetails?.exchangeRate);
        this.orderTotal = Number(this.billDetails.netAmount) * Number(this.billDetails?.exchangeRate);
        this.discount = Number(this.billDetails.discountAmount) * Number(this.billDetails?.exchangeRate);
        this.billDetails.taxAmount = Number(this.billDetails.taxAmount) * Number(this.billDetails?.exchangeRate);
        if (this.billDetails.billOrderProducts?.length > 0) {
            for (let l of this.billDetails.billOrderProducts) {
                const bundleProducts: any[] = [];
                if (l.billOrderBundleDetail?.length > 0) {
                    for (let prd of l.billOrderBundleDetail) {
                        let eachProduct = {
                            id: prd.id,
                            productId: prd.productId,
                            poNo: prd.purchaseOrderNo,
                            subProductId: prd.subProductId,
                            itemNo: prd.product?.itemNo,
                            typeId: prd.products?.typeId,
                            description: prd.product?.description,
                            quantity: prd.quantity,
                            unit: prd.productUnitId,
                            uom: prd.product?.productUOM
                                .filter(
                                    (uom) =>
                                        uom.unitOfMeasureId == prd.productUnitId
                                )
                                .map((x) => x.uomDetail?.name)[0],
                            cost: parseFloat(prd.totalAmount).toFixed(this.length),
                            pricePerProduct: parseFloat(
                                prd.pricePerProduct
                            ).toFixed(this.length),
                            trackingEnabled: prd.product?.isTrackingRequired,
                            serialSettings: prd.product?.serialSettings
                                ? JSON.parse(prd.product?.serialSettings)
                                : null,
                            billOrderBundleSerialDetail:
                                prd.billOrderBundleSerialDetail,
                            serialCount: prd.serialCount
                        };
                        bundleProducts.push(eachProduct);
                    }
                }
                let eachProduct = {
                    id: l.id,
                    poNo: l.purchaseOrderNo,
                    productId: l.productId,
                    itemNo: l.product?.itemNo,
                    description: l?.description,
                    uom: l.product?.productUOM
                        ?.filter(
                            (uom) => uom.unitOfMeasureId == l.productUnitId
                        )
                        .map((x) => x.uomDetail?.name)[0],
                    unit: l.productUnitId,
                    warehouseId: l.warehouseId,
                    quantity: l.quantity,
                    pricePerProduct: (Number(l.pricePerProduct) * Number(this.billDetails?.exchangeRate)).toFixed(this.length),
                    cost: Number(l.totalAmount) * Number(this.billDetails?.exchangeRate),
                    netAmount: Number(l.netAmount) * Number(this.billDetails?.exchangeRate),
                    typeId: l.product?.typeId,
                    trackingEnabled: l.product?.isTrackingRequired,
                    serialSettings: l.product?.serialSettings
                        ? JSON.parse(l.product?.serialSettings)
                        : null,
                    billOrderProductSerialDetail: l.billOrderSerialDetail,
                    serialCount: l.serialCount,
                    products: bundleProducts,
                    taxAmount: l.billOrderProductSubTax?.reduce((sum, s) => sum + (Number(s.taxAmount) * this.billDetails?.exchangeRate), 0)
                };
                this.receivePurchaseListTB.push(eachProduct);
            }
        }
        this.lineTotal = this.receivePurchaseListTB?.reduce((sum, s) => sum + (Number(s.netAmount)), 0);
    }

    showScanInfo(e) {
        if (e.serialCount > 0) {
            e.type = 'product';
            e.billOrderId = this.billDetails?.id;
            this.openScanInfoChild.emit(e);
        }
    }

    updateJournal() {
        this.updateJournalList.emit();
    }

    closeDialog() {
        this.close.emit();
    }

    onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }
    getIsettings(){
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
      }
}
